import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Document } from './document.model';
import { Partner, PartnerDocument } from './partner.model';

@CwtModel({ name: 'prestation', path: '/prestation' })
export class Prestation extends ApiData {
    partners?: Partner[];
    name?: DictionaryObject;
    subtitle?: DictionaryObject;
    description?: DictionaryObject;
    resaInstruction?: DictionaryObject;
    isActive?: boolean;
    isFree?: boolean;
    isReservable?: boolean;
    isTimeBooking: boolean;
    isLocationBooking: boolean;
    minTimeBooking: string;
    maxTimeBooking: string;
    blockingTimeBeforeBooking: number;
    picture?: Document;
    pictures?: Document[];
    documents?: PartnerDocument[];
    link?: string;

    fieldDictionary() {
        return {
            partners: [Partner]
        };
    }
}
